import React from "react";

interface ConditionDescriptionsProps {
  internal_description?: string;
  external_description?: string;
}

export function ConditionDescriptions({
  internal_description,
  external_description,
}: ConditionDescriptionsProps) {
  if (!internal_description && !external_description) {
    return <p className="text-sm text-[#9AA2B2] italic">No description</p>;
  }

  return (
    <div className="flex flex-col gap-2 text-sm">
      {external_description ? (
        <p className="text-[#697083] whitespace-pre-wrap">
          {external_description}
        </p>
      ) : (
        <p className="text-[#9AA2B2] italic">No external description</p>
      )}
      {internal_description ? (
        <p className="text-[#9AA2B2] whitespace-pre-wrap">
          <span className="font-medium text-[#697083]">Internal: </span>
          {internal_description}
        </p>
      ) : null}
    </div>
  );
}
